import { currencyToSymbol } from '@/utilities/formatting';
import { CompanyIntrinsicDiscount } from '@/components/CompanyIntrinsicDiscount';

import type { NarrativeValuatorCompany } from '../../../hooks/narrativeValuatorCompanyFragment';
import { FairValueInput } from './FairValueInput';
import { getTradingItemCurrencyISO } from '@/utilities/getTradingItemCurrencyISO';

export type Props = {
  company: NarrativeValuatorCompany;
  onChange: (fairValue: number) => void;
  fairValue: number;
};

export const NarrativeValuatorCalculation = ({
  company,
  onChange,
  fairValue,
}: Props) => {
  const companyCurrencySymbol = currencyToSymbol[
    getTradingItemCurrencyISO(company.data.currencyInfo) ?? ('XXX' as const)
  ].currency.symbol as string;

  return (
    <div className="grid rounded-t-x1 bg-p-grey-30">
      <label
        htmlFor="narrative-valuator-fair-value"
        className="m-0 px-x2 pt-x2 text-sm text-solid"
      >
        Fair Value
      </label>

      <div className="grid grid-cols-[1fr_auto] items-center gap-x2 p-x2">
        <FairValueInput
          currencySymbol={companyCurrencySymbol}
          onChange={onChange}
          value={fairValue}
        />

        <CompanyIntrinsicDiscount
          lastSharePrice={company.analysisValue?.lastSharePrice ?? null}
          npvPerShare={company.analysisValue?.npvPerShare ?? null}
          fairValue={fairValue}
        />
      </div>
    </div>
  );
};
